import React, { useMemo } from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import ORSMWorkplaceSettings, {
	ORSMWorkplaceSettingsType,
} from './ORSMWorkplaceSettings';
import { Size } from '../../../../Enums/Size.enum';
import { Workplace } from '../../../../graphql/graphql';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props extends BaseModalProps {
	type: ORSMWorkplaceSettingsType;
	workplace: Workplace;
	changeType: (type: ORSMWorkplaceSettingsType) => void;
	onWorkplaceUpdate: () => Promise<void>;
}

const ORSMWorkplaceSettingsModal: React.FC<Props> = props => {
	const { t } = useTranslation();

	const title: string = useMemo(() => {
		const end = `- ${props.workplace.doctorDisplayName}`;
		switch (props.type) {
			case ORSMWorkplaceSettingsType.CASE_TYPES:
				return `${t('component.ORSMWorkplaceSettingsModal.caseTypes')} ${end}`;
			case ORSMWorkplaceSettingsType.ONLINE_ORDERING:
				return `${t(
					'component.ORSMWorkplaceSettingsModal.onlineOrdering',
				)} ${end}`;
			case ORSMWorkplaceSettingsType.SHIFTS:
				return `${t('component.ORSMWorkplaceSettingsModal.shifts')} ${end}`;
			case ORSMWorkplaceSettingsType.RESTRICTION:
				return `${t(
					'component.ORSMWorkplaceSettingsModal.restriction',
				)} ${end}`;
		}
	}, [props.type]);

	return (
		<BaseModal
			{...props}
			title={title}
			contentScroll={false}
			contentStyle={{ height: '100%' }}
			size={
				props.type === ORSMWorkplaceSettingsType.RESTRICTION
					? Size.LG
					: Size.FULLSCREEN
			}>
			<ORSMWorkplaceSettings
				type={props.type}
				workplace={props.workplace}
				changeType={props.changeType}
				onClose={props.onClose}
				onWorkplaceUpdate={props.onWorkplaceUpdate}
			/>
		</BaseModal>
	);
};

export default ORSMWorkplaceSettingsModal;
